import type { ComputedRef, MaybeRefOrGetter } from 'vue';
import { computed, toValue } from 'vue';

/**
 * Marker property present on skeleton rows so cells can identify them even
 * when the loading state changes but the data prop still holds skeletons
 * (race observed in staging where rows render `RenderFieldDisplay` against
 * a placeholder row, producing a table of "--" empty states).
 */
export const SKELETON_ROW_FLAG = '$__skeletonRow' as const;

export function isSkeletonRow(row: unknown): boolean {
	return !!row && typeof row === 'object' && (row as Record<string, unknown>)[SKELETON_ROW_FLAG] === true;
}

export function useSkeletonItems<T = unknown>(pageSize: MaybeRefOrGetter<number>): ComputedRef<T[]> {
	return computed(() => Array.from({ length: Math.min(100, toValue(pageSize)) }).map((_, i) => ({
		id: String(i),
		[SKELETON_ROW_FLAG]: true,
	})) as T[]);
}
